import { render, staticRenderFns } from "./location-search-box.vue?vue&type=template&id=2fb956ae"
import script from "./location-search-box.vue?vue&type=script&lang=js"
export * from "./location-search-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports